import React from "react";
import HackRoomDashBoard from "../components/hacks/HackRoomDashboard";

import HackLayout from "../components/hacks/HackLayout";

const HackRoomDashboardPage = () => {
  return (
    <HackLayout activeId="1">
      <HackRoomDashBoard />
    </HackLayout>
  );
};

export default HackRoomDashboardPage;
